import styled from "styled-components"

export const WaterWrapper = styled.div`
  width: 100%;
  padding: 8px 8px 8px 0px;
  border-radius: var(--spacing_s, 8px);
  border: 0.5px solid var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  background: var(--Primitive-White_10, rgba(255, 255, 255, 0.1));

  display: flex;
  justify-content: space-between;

  @supports (-webkit-touch-callout: none) {
    border: 0.8px solid var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  }
`

export const WaterTitle = styled.h5`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.48px;
  text-transform: uppercase;
`

export const WaterValueBox = styled.div`
  display: flex;
`

export const WaterValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 120%;
  color: var(--Schemes-Surface-Surface-Container-Lowest, #fff);
`

export const WaterUnit = styled.span`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-size: 14px;
  font-weight: 400;
  margin-left: 2px;
  margin-right: 4px;
  line-height: 24px;
  position: relative;
  top: 1.2px;
`
export const ClickToEditArea = styled.div`
  padding: 0px 15px;
`
